import { USE_API } from '../../config/env';
import { getContentByType } from '../../services/contentService';
import * as types from '../types/contentTypes';

const readLocale = () =>
  (typeof window !== 'undefined' && (localStorage.getItem('shop-locale') || '').trim()) || 'en-US';

export const getContentAction = (contentKey) => async (dispatch) => {
  if (!USE_API) return null;
  const key = String(contentKey || '').trim();
  if (!key) return null;
  const locale = readLocale();
  dispatch({ type: types.GET_CONTENT_REQUEST, payload: { contentKey: key, locale } });
  try {
    const data = await getContentByType(key);
    dispatch({
      type: types.GET_CONTENT_SUCCESS,
      payload: { contentKey: key, locale, data },
    });
    return data;
  } catch (e) {
    dispatch({
      type: types.GET_CONTENT_FAILURE,
      payload: {
        contentKey: key,
        locale,
        message: e?.response?.data?.message || e?.message || 'Failed to load content',
      },
    });
    return null;
  }
};
